import React from "react";
import { useTheme, Button, Typography } from "@mui/material";
import { getDashboardStyle } from "../../components/customstyles/DashboardStyle";
import { useHistory } from "react-router-dom";

const useStyles = () => {
  const theme = useTheme();
  return getDashboardStyle(theme);
};
const AssessmentAction = (props) => {
  const styles = useStyles();
  const history = useHistory();

  const handleAssessmentClick = (e) => {
    localStorage.removeItem("addedThroughSource");
    e.stopPropagation();
    history.push({
      pathname: `/patients/${props.patientId}/assessment`,
    });
  };
  return (
    <Button
      color="inherit"
      aria-haspopup="true"
      onClick={handleAssessmentClick}
      sx={styles.assessmentButton}
    >
      <Typography sx={styles.assessmentButtonText}>New Assessment</Typography>
    </Button>
  );
};

export default AssessmentAction;
